// extracted by mini-css-extract-plugin
module.exports = {"container":"Slider_container__Lk0-r","label":"Slider_label__jApoc","input":"Slider_input__nk_-R"};